export enum InterviewInviteTrigger {
  CommittedUser = 'committed_user',
  LoyalUser = 'loyal_user',
}

export enum InterviewInviteOutcome {
  Responded = 'responded',
  Dismissed = 'dismissed',
}
